export default "__VITE_ASSET__jI3hPryo__"